import React from 'react';
import { Outlet } from 'react-router-dom';

const IndexPlayers = () => {

    return <Outlet/>

}

export default IndexPlayers